import React from "react";
import theme from "../../../styles/theme";



const Page46 = () => {
  return (

    <div>
    <h2>"Page 46" </h2>
    </div>

  );
};

export default Page46;
